
define('Code25.CaterpartsGlobal.Payments'
    , [

        'Backbone', 'Profile.Model', 'Utils'
    ]
    , function (
        Backbone, ProfileModel, Utils
    ) {
        'use strict';

        return {
            mount: function (container) {

                var OrderWizardModulePaymentMethodSelector = require("OrderWizard.Module.PaymentMethod.Selector");

                if (ProfileModel.ProfileModel) {
                    ProfileModel = ProfileModel.ProfileModel;
                }
                var profile = ProfileModel.getInstance();

                _.extend(OrderWizardModulePaymentMethodSelector.prototype, {

                    initialize: _.wrap(OrderWizardModulePaymentMethodSelector.prototype.initialize, function (initialize) {

                        var res = initialize.apply(this, _.rest(arguments));

                        var paymentterms = profile.get("paymentterms"), id;


                        if (paymentterms) {
                            id = paymentterms.internalid;
                            paymentterms = paymentterms.name;
                        }


                        var noinvoice = ["9"];
                        var hideInvoice;
                        for (var i = 0; i < noinvoice.length; i++) {
                            if (id == noinvoice[i]) {
                                hideInvoice = true;
                                break;
                            }
                        }

                        if (hideInvoice) {

                            for (var i = this.modules.length - 1; i >= 0; i--) {
                                if (this.modules[i].type == "invoice") {

                                    this.modules.splice(i, 1);
                                }
                            }
                        }
                        return res;

                    })
                });

            }
        }

    });
//activeModulesLengthGreaterThan1
